import { render, staticRenderFns } from "./AutorizacionesCambio.vue?vue&type=template&id=0199c250"
import script from "./AutorizacionesCambio.vue?vue&type=script&lang=js"
export * from "./AutorizacionesCambio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports